import { useContext } from 'react'

import { AuthContext } from './auth-context'
import type { AuthState } from './auth-context'

export function useAuth(): AuthState {
  const state = useContext(AuthContext)
  if (!state) throw new Error('useAuth used outside AuthProvider')
  return state
}
